import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import createApiClient from '@/api/axiosInstance';

const ForgotPasswordScreen = ({ email, setEmail, setEmailSent }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const apiClient = createApiClient(navigate, dispatch);

  const [message, setMessage] = useState('');
  const [incorrect, setIncorrect] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const validateEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      setMessage('Please enter a valid Email ID.');
      setIncorrect(true);
    } else {
      setMessage('');
      setIncorrect(0, false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value.trim();

    if (name === 'email') {
      setEmail(trimmedValue);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form inputs
    if (!email) {
      setMessage('Please enter email');
      setIncorrect(!email);
      return;
      setMessage('Please enter email');
      setIncorrect(!email);
      return;
    }

    // Reset validation errors
    setIncorrect(false);
    validateEmail();

    if (message === '') {
      setIsLoading(true);
      setIsLoading(true);

      try {
        // Step 1: Send Email To User
        const response = await apiClient.post(
          '/forgot-password',
          JSON.stringify({
            email,
          }),
          {
            authRequired: false,
          },
        );

        const data = response.data;
        setEmailSent(true);
      } catch (error) {
        const error_message = error?.response?.data?.error_message;
        console.error('Network or Unexpected Error:', error_message);
        setError(error_message || 'Network error. Please try again later.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="flex flex-col space-y-3 items-center justify-center border-gray-400 rounded-lg px-12 w-5/6">
      <div className="w-full">
        <input
          name="email"
          type="email"
          value={email}
          onChange={handleInputChange}
          onBlur={() => validateEmail()}
          className={`rounded-md bg-gray-100 border px-4 py-2 w-full ${
            incorrect
              ? 'outline-red-400  border-red-400 hover:border-red-500'
              : 'outline-veryLightPurple  transition ease-in-out duration-300 border-gray-400/70 hover:border-lightPurple'
          }`}
          placeholder="Enter your email"
        />
      </div>
      {message && message !== '' && (
        <div className="mt-3 py-3 px-3 rounded-lg bg-[#F8D7D7] text-[#B64444] text-[10px] w-full">
          <p className="text-sm">{message}</p>
        </div>
      )}
      {error && (
        <div className="mt-3 py-3 px-3 rounded-lg bg-[#F8D7D7] text-[#B64444] text-[10px] w-full">
          <p className="text-sm">{error}</p>
        </div>
      )}
      <button
        onClick={(e) => handleSubmit(e)}
        disabled={isLoading}
        className={`w-full text-white font-roboto font-semibold rounded-lg mt-3 p-2 text-lg transition ease-in-out duration-300
          ${
            isLoading
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-darkPurple hover:bg-darkerPurple'
          } flex items-center justify-center`}
      >
        {isLoading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Sending...
          </>
        ) : (
          'Send Reset Password link'
        )}
      </button>
      <div className="flex items-center justify-center w-full py-2">
        <hr className="flex-grow border-gray-300" />
        <span className="mx-3 text-gray-500 text-sm font-medium">or</span>
        <hr className="flex-grow border-gray-300" />
      </div>
      <p className="text-center text-md mt-2 text-gray-600 font-roboto">
        <button
          onClick={() =>
            navigate('/signup', {
              state: !incorrect[0] ? { email: email } : 'undefined',
            })
          }
          className="cursor-pointer ml-1 text-[rgba(118,54,217,1)] font-semibold hover:underline"
        >
          Create new account
        </button>
      </p>
    </div>
  );
};

export default ForgotPasswordScreen;
